const uniqueArray = <T>(arr: T[]): T[] => [...new Set(arr)];

export default uniqueArray;
